var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g2, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWandLadyBranding = (_ref, ref) => {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 572,
    height: 682,
    viewBox: "0 0 572 682",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Lady holding a wand and a web browser") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 651.711C5.5 667.44 18.251 680.191 33.9801 680.191H514.179C529.909 680.191 542.66 667.44 542.66 651.711V315.483C542.66 299.754 529.909 287.003 514.179 287.003H33.9801C18.251 287.003 5.5 299.754 5.5 315.483V651.711Z",
    fill: "white",
    stroke: "#EDEDED",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1479_33433",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 288,
    width: 565,
    height: 391
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 678.691H571.525V288.503H7V678.691Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1479_33433)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.6 284.906L352.047 288.27C352.047 288.27 343.436 288.639 344.137 299.131L328.024 305.361C328.024 305.361 320.719 307.768 322.524 312.58C324.329 317.393 333.095 314.815 333.095 314.815C333.095 314.815 331.032 322.979 348.306 320.315C348.306 320.315 345.304 326.539 356.879 327.777C368.454 329.014 394.603 329.684 394.603 329.684L380.6 284.906Z",
    fill: "#E68F5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.864 107.497L491.408 149.802H452.346L455.607 126.258C441.536 126.634 427.255 123.043 418.867 111.574C410.478 100.105 414.4 86.1152 417.805 79.311C420.874 73.1703 429.85 56.8422 439.436 42.9573C440.476 41.4513 441.522 39.9753 442.567 38.5451C447.562 31.7111 455.759 27.1822 464.278 26.0147H464.281C474.016 24.6766 484.17 27.7295 490.452 36.7494C502.11 53.4972 492.518 75.0636 492.329 75.4863",
    fill: "#E68F5B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M566.208 185.573L553.636 225.74L539.637 270.456L536.43 280.702C536.43 280.702 530.524 299.334 523.942 306.789C520.128 311.112 515.761 313.954 511.639 315.824C510.448 316.366 509.278 316.827 508.145 317.216C501.496 319.509 496.218 319.416 496.218 319.416L462.536 322.818L458.557 323.22L394.602 329.683L380.6 284.906L392.235 280.136L393.869 246.242L387.376 252.285L356.796 280.743C356.796 280.743 354.697 282.582 351.057 284.605C344.663 288.157 333.516 292.265 320.664 287.921C301.499 281.449 297.887 255.785 297.887 255.785L292.37 230.691L281.892 183.048L275.59 154.381L317.01 137.339L346.83 205.798L375.81 172.495L388.42 158.005C388.42 158.005 395.974 149.919 402.695 145.719C406.397 143.405 412.139 143.173 416.548 143.429C420.144 143.641 422.852 144.176 422.852 144.176L452.345 149.803L454.071 137.339H489.186L491.407 149.803L520.101 142.918L529.255 140.724C529.255 140.724 546.399 134.906 561.469 150.649C563.752 153.034 565.311 155.859 566.345 158.851C570.497 170.851 566.208 185.573 566.208 185.573Z",
    fill: "#3FC88F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M467.878 72.2349L459.917 69.0186L460.684 67.1205L468.645 70.3369L467.878 72.2349Z",
    fill: "#30252A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.485 210.271C474.485 224.264 463.142 235.607 449.149 235.607C435.157 235.607 423.813 224.264 423.813 210.271C423.813 196.278 435.157 184.935 449.149 184.935C463.142 184.935 474.485 196.278 474.485 210.271Z",
    fill: "#26AA6B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.574 63.0379L432.534 62.5773L432.668 60.5347L439.708 60.9953L439.574 63.0379Z",
    fill: "#30252A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M438.486 86.2262C437.211 85.2443 436.557 84.1092 436.544 82.8523C436.523 80.859 438.15 79.4373 438.421 79.2149L443.212 75.0063L444.562 76.5444L439.724 80.7939C439.407 81.0542 438.577 81.9355 438.591 82.8379C438.6 83.4326 438.985 84.027 439.735 84.6042L438.486 86.2262Z",
    fill: "#84401E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.3 77.9463C460.3 78.6802 459.705 79.2753 458.971 79.2753C458.237 79.2753 457.643 78.6802 457.643 77.9463C457.643 77.2125 458.237 76.6174 458.971 76.6174C459.705 76.6174 460.3 77.2125 460.3 77.9463Z",
    fill: "#30252A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.297 69.9571C434.297 70.691 433.701 71.286 432.968 71.286C432.234 71.286 431.639 70.691 431.639 69.9571C431.639 69.2232 432.234 68.6282 432.968 68.6282C433.701 68.6282 434.297 69.2232 434.297 69.9571Z",
    fill: "#30252A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.877 35.7748C386.877 36.3653 386.398 36.8444 385.807 36.8444C385.216 36.8444 384.737 36.3653 384.737 35.7748C384.737 35.1842 385.216 34.7051 385.807 34.7051C386.398 34.7051 386.877 35.1842 386.877 35.7748Z",
    fill: "#30252A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.196 20.7428C304.196 21.3337 303.718 21.8124 303.127 21.8124C302.536 21.8124 302.057 21.3337 302.057 20.7428C302.057 20.1522 302.536 19.6732 303.127 19.6732C303.718 19.6732 304.196 20.1522 304.196 20.7428Z",
    fill: "#30252A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.164 3.59049C373.164 4.18108 372.685 4.66011 372.094 4.66011C371.503 4.66011 371.024 4.18108 371.024 3.59049C371.024 2.9999 371.503 2.52087 372.094 2.52087C372.685 2.52087 373.164 2.9999 373.164 3.59049Z",
    fill: "#30252A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.585 93.5839C444.987 93.5839 444.484 93.4801 444.083 93.3467C442.945 92.9673 442.347 92.2604 442.282 92.1809L443.077 91.5357L443.86 90.8766C443.994 91.0291 445.241 92.3208 447.918 90.8329C450.261 89.5316 451.566 86.509 451.578 86.4783L453.463 87.2788C453.399 87.4292 451.863 90.983 448.912 92.6227C447.607 93.3478 446.488 93.5839 445.585 93.5839Z",
    fill: "#84401E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M455.657 127.28L455.554 125.236C455.618 125.232 462.047 124.884 466.559 122.782L467.423 124.638C462.545 126.911 455.935 127.266 455.657 127.28Z",
    fill: "#84401E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M492.328 75.4862L492.326 75.4917C492.326 75.4917 460.499 84.5792 464.28 26.0147C474.015 24.6765 484.17 27.7294 490.451 36.7494C502.11 53.4972 492.518 75.0635 492.328 75.4862Z",
    fill: "#30252A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M464.277 26.0146C464.039 26.318 447.09 47.9631 439.436 42.9576C440.475 41.4516 441.521 39.9753 442.567 38.545C447.562 31.7111 455.758 27.1822 464.277 26.0146Z",
    fill: "#30252A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M519.682 131.222C511.855 142.953 497.502 147.12 487.625 140.529C477.747 133.938 476.085 119.085 483.912 107.354C491.74 95.6238 506.093 91.4573 515.97 98.0483C525.848 104.639 527.51 119.492 519.682 131.222Z",
    fill: "#30252A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.59 196.661C514.447 199.812 505.644 196.677 502.928 189.658C500.212 182.639 504.612 174.394 512.755 171.243C520.898 168.092 529.701 171.228 532.418 178.247C535.133 185.266 530.734 193.51 522.59 196.661Z",
    fill: "#30252A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491.328 75.4862L491.325 75.4916C491.325 75.4916 509.731 71.6912 507.621 87.7566C505.05 107.324 482.863 107.497 482.863 107.497",
    fill: "#E68F5B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M489.725 89.8059L489.312 87.8011L501.063 85.3742L501.476 87.379L489.725 89.8059Z",
    fill: "#84401E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.902 215.411L338.351 214.075L346.056 205.132L347.607 206.468L339.902 215.411Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.889 246.3L392.846 246.185L396.001 190.207L398.044 190.322L394.889 246.3Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M480.545 245.545L478.605 244.889L493.893 199.687L495.832 200.342L480.545 245.545Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.758 159.818L449.737 159.491L451.336 149.638L453.356 149.966L451.758 159.818Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.345 315.807L332.844 313.822L351.264 309.168L351.765 311.153L333.345 315.807Z",
    fill: "#84401E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.469 321.325L348.143 319.304L358.754 317.589L359.081 319.611L348.469 321.325Z",
    fill: "#84401E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.601 313.774C336.595 313.718 336.43 312.393 335.022 311.593C333.435 310.692 330.052 310.294 322.946 313.512L322.102 311.648C328.481 308.758 333.189 308.152 336.093 309.848C338.402 311.196 338.631 313.484 338.639 313.581L336.6 313.762L337.619 313.671L336.601 313.774Z",
    fill: "#84401E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.475 300.098L343.8 298.165L364.844 290.819L365.519 292.751L344.475 300.098Z",
    fill: "#84401E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.012 137.339L312.079 112.446C312.079 112.446 310.703 104.65 308.292 101.637C305.882 98.6234 296.391 89.0821 296.391 89.0821C296.391 89.0821 290.214 82.4532 287 86.3202C283.786 90.1869 287 94.9075 287 94.9075C287 94.9075 283.973 92.089 282.068 91.5772C279.801 90.9682 273.858 91.2204 272.133 93.481C270.408 95.7417 270.824 99.2515 270.824 99.2515C270.824 99.2515 261.427 97.9943 263.981 108.321C263.981 108.321 260.526 107.124 260.612 111.781C260.698 116.438 263.191 133.86 263.191 133.86C263.191 133.86 264.06 138.64 268.095 138.267C272.13 137.895 271.757 132.432 271.757 132.432L275.59 154.381",
    fill: "#E68F5B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.975 113.277C291.818 107.178 286.307 95.8308 286.077 95.3508L287.922 94.4641C287.977 94.5773 293.451 105.843 301.201 111.638L299.975 113.277Z",
    fill: "#84401E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.379 94.7745C296.096 94.7745 295.809 94.7534 295.518 94.7111C290.569 93.9922 286.307 87.1477 286.128 86.8563L287.871 85.7833C288.954 87.5404 292.493 92.2047 295.815 92.6854C296.965 92.8513 297.997 92.5084 298.972 91.6353L300.338 93.1597C299.14 94.2334 297.812 94.7745 296.379 94.7745Z",
    fill: "#84401E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.028 132.42C276.995 132.42 274.832 130.011 274.002 128.454L263.087 108.819L264.876 107.824L275.799 127.475C275.894 127.649 277.984 131.417 281.537 130.08C283.683 129.271 283.228 124.735 282.9 123.21L284.9 122.776C284.968 123.086 286.504 130.396 282.258 131.995C281.473 132.291 280.727 132.42 280.028 132.42Z",
    fill: "#84401E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.098 126.901C286.423 126.901 284.137 124.98 283.088 123.617L283.025 123.525L270.736 103.329C269.733 101.523 269.798 99.3093 269.801 99.2158L271.847 99.2868L270.824 99.2513L271.847 99.2844C271.846 99.3018 271.804 101.02 272.516 102.318L284.741 122.408C285.083 122.831 287.925 126.169 291.066 124.271C291.724 123.873 292.123 123.333 292.288 122.619C292.742 120.64 291.298 117.831 290.704 116.915L282.682 104.23L284.412 103.135L292.427 115.81C292.527 115.964 295.022 119.857 294.282 123.078C293.992 124.342 293.266 125.333 292.125 126.023C291.092 126.647 290.069 126.901 289.098 126.901Z",
    fill: "#84401E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.7 125.642C287.346 119.562 285.03 118.571 283.948 118.522C282.854 118.472 282.243 119.351 282.218 119.389L280.503 118.271C280.552 118.195 281.733 116.403 283.993 116.475C286.689 116.566 289.549 119.318 292.493 124.653L290.7 125.642Z",
    fill: "#84401E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.736 132.499L270.312 125.948L272.354 125.815L272.779 132.366L270.736 132.499Z",
    fill: "#84401E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.051 94.5123L300.317 93.4243L325.897 52.6628L327.631 53.7509L302.051 94.5123Z",
    fill: "#30252A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.208 113.387L288.474 112.299L292.97 105.134L294.704 106.222L290.208 113.387Z",
    fill: "#30252A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1479_33433",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 252,
    y: 130,
    width: 27,
    height: 42
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252 130.392H278.852V171.507H252V130.392Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1479_33433)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.734 171.507L252 170.419L277.118 130.392L278.852 131.481L253.734 171.507Z",
    fill: "#30252A"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.984 62.6171L321.577 81.6894C321.631 83.4564 324.07 83.8778 324.714 82.2319L331.976 63.6943L348.245 73.2891C349.777 74.1919 351.438 72.3338 350.37 70.9127L339.023 55.8108L354.788 46.9431C356.34 46.07 355.56 43.6963 353.793 43.9137L334.723 46.2552L334.888 27.6552C334.903 25.8677 332.442 25.3685 331.76 27.0209L324.809 43.8666L308.109 35.1138C306.558 34.3008 304.995 36.179 306.076 37.5567L317.403 51.9889L300.77 62.363C299.279 63.293 300.121 65.5994 301.86 65.3507L320.984 62.6171Z",
    fill: "#FFBE21"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.993 24.0935C368.22 25.1423 367.569 26.2726 367.078 27.5006C366.442 29.0895 366.444 30.0915 366.545 30.4777C367.331 29.838 368.723 26.8892 368.989 25.6275C369.086 25.1699 369.111 24.6134 368.993 24.0935ZM349.629 35.2758L347.931 34.1339C352.171 27.8261 358.25 22.595 363.415 20.8072C365.623 20.0426 367.589 20.0863 369.005 20.8973C371.458 18.3022 374.546 16.2261 377.66 14.3492C383.119 11.0605 388.373 9.13522 395.229 7.91241L395.588 9.92746C388.994 11.1042 383.948 12.951 378.717 16.1029C375.73 17.9023 372.775 19.8846 370.471 22.3299C371.083 23.3541 371.279 24.6892 370.992 26.0495C370.817 26.8806 369.257 31.3341 367.379 32.3672C366.732 32.7231 366.185 32.6439 365.839 32.5153C365.339 32.3283 364.949 31.9476 364.713 31.4143C364.244 30.3532 364.413 28.6497 365.177 26.7404C365.798 25.188 366.632 23.7868 367.624 22.5056C366.356 22.0402 364.666 22.5404 364.085 22.7417C359.312 24.3934 353.638 29.3136 349.629 35.2758Z",
    fill: "#22C67B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.121 25.1057L345.29 24.1906L357.368 0.0135498L359.199 0.928268L347.121 25.1057Z",
    fill: "#7784F5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.848 22.006L317.847 1.22406L319.857 0.837158L323.858 21.6188L321.848 22.006Z",
    fill: "#FFB7D5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M553.636 225.74L539.637 270.456C538.91 270.521 538.176 270.552 537.433 270.552C523.441 270.552 512.1 259.211 512.1 245.219C512.1 231.223 523.441 219.882 537.433 219.882C543.594 219.882 549.244 222.083 553.636 225.74Z",
    fill: "#26AA6B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M566.345 158.851C561.787 165.555 554.097 169.96 545.379 169.96C531.387 169.96 520.043 158.616 520.043 144.624C520.043 144.05 520.063 143.481 520.101 142.918L529.255 140.724C529.255 140.724 546.4 134.906 561.47 150.649C563.752 153.034 565.311 155.859 566.345 158.851Z",
    fill: "#26AA6B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M511.64 315.824C510.449 316.366 509.279 316.827 508.146 317.216C501.496 319.509 496.218 319.416 496.218 319.416L462.536 322.818C463.382 309.593 474.379 299.129 487.818 299.129C498.773 299.129 508.108 306.086 511.64 315.824Z",
    fill: "#26AA6B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.546 266.447C451.546 280.443 440.202 291.784 426.21 291.784C415.575 291.784 406.472 285.233 402.716 275.946L449.779 257.129C450.918 260.013 451.546 263.158 451.546 266.447Z",
    fill: "#26AA6B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.173 205.399C319.173 219.391 307.829 230.735 293.837 230.735C293.345 230.735 292.854 230.722 292.369 230.691L281.892 183.048C285.45 181.144 289.517 180.062 293.837 180.062C307.829 180.062 319.173 191.407 319.173 205.399Z",
    fill: "#26AA6B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M419.202 154.73C419.202 168.722 407.861 180.063 393.869 180.063C386.796 180.063 380.402 177.166 375.81 172.495L388.42 158.005C388.42 158.005 395.974 149.918 402.695 145.719C406.397 143.406 412.139 143.174 416.547 143.429C418.246 146.831 419.202 150.669 419.202 154.73Z",
    fill: "#26AA6B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.376 252.285L356.796 280.743C356.796 280.743 354.698 282.582 351.057 284.605C343.892 280.132 339.126 272.172 339.126 263.104C339.126 249.112 350.47 237.767 364.462 237.767C374.585 237.767 383.319 243.704 387.376 252.285Z",
    fill: "#26AA6B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.615 281.087L391.854 279.185L491.72 239.26L492.479 241.161L392.615 281.087Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.7 164.263C525.729 173.514 513.152 175.744 505.61 169.245C498.067 162.745 498.414 149.977 506.385 140.726C514.356 131.475 526.932 129.245 534.475 135.744C542.019 142.244 541.671 155.013 533.7 164.263Z",
    fill: "#30252A"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1479_33433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.83 379.364H219.586C214.604 379.364 210.565 383.402 210.565 388.384V507.428C210.565 512.41 214.604 516.448 219.586 516.448H395.83C400.811 516.448 404.85 512.41 404.85 507.428V388.384C404.85 383.402 400.811 379.364 395.83 379.364Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.61568,
    strokeMiterlimit: 10,
    strokeDasharray: "6.06 6.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.917 452.664H132.028C127.046 452.664 123.008 456.702 123.008 461.683V580.967C123.008 585.948 127.046 589.986 132.028 589.986H242.917C247.899 589.986 251.937 585.948 251.937 580.967V461.683C251.937 456.702 247.899 452.664 242.917 452.664Z",
    fill: "#3FC88F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.155 379.006H48.849C44.9396 379.006 41.7705 383.07 41.7705 388.083V507.884C41.7705 512.897 44.9396 516.961 48.849 516.961H187.155C191.064 516.961 194.233 512.897 194.233 507.884V388.083C194.233 383.07 191.064 379.006 187.155 379.006Z",
    fill: "#FFBE21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.189 460.686L484.71 403.369",
    stroke: "#FA3B3C",
    strokeWidth: 2.42351,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.728 490.914C497.076 490.914 498.168 489.822 498.168 488.475C498.168 487.127 497.076 486.035 495.728 486.035C494.381 486.035 493.288 487.127 493.288 488.475C493.288 489.822 494.381 490.914 495.728 490.914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.884 465.164C477.637 457.647 479.811 454.305 484.61 450.017C485.668 448.983 486.914 448.161 488.281 447.595C488.966 447.317 489.705 447.196 490.444 447.24C491.182 447.285 491.901 447.494 492.548 447.852C494.681 449.173 494.97 452.141 494.758 454.616C494.48 457.892 493.746 461.114 492.575 464.186C492.252 465.202 491.696 466.129 490.951 466.892C490.157 467.604 488.931 467.938 487.997 467.419C487.601 467.16 487.281 466.8 487.071 466.376C486.861 465.951 486.768 465.479 486.802 465.007C486.884 464.061 487.154 463.141 487.596 462.301C492.615 451.243 502.885 442.878 518.58 437.57",
    stroke: "#FCE268",
    strokeWidth: 2.42351,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.178 356.014H242.934C237.953 356.014 233.914 360.052 233.914 365.033V484.078C233.914 489.059 237.953 493.097 242.934 493.097H419.178C424.16 493.097 428.199 489.059 428.199 484.078V365.033C428.199 360.052 424.16 356.014 419.178 356.014Z",
    fill: "#4756DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.048 412.912L325.325 391.031C325.325 391.031 330.791 379.225 337.245 381.43C343.288 383.491 340.537 391.698 340.537 391.698C340.537 391.698 345.872 383.689 352.412 386.891C358.952 390.093 354.55 400.501 354.55 400.501C354.55 400.501 359.827 396.104 364.278 398.445C369.18 401.024 366.082 408.939 365.144 410.927L345.394 453.318C343.301 457.932 339.867 461.81 335.54 464.447C329.848 467.825 321.238 469.809 309.557 464.235C292.288 455.987 295.355 433.57 295.355 433.57L296.956 402.693C296.956 402.693 297.538 387.049 306.08 387.315C314.622 387.581 314.491 410.314 314.491 410.314",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.538 391.698L329.082 415.036",
    stroke: "#30252A",
    strokeWidth: 2.0196,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.55 400.505L343.329 423.243",
    stroke: "#30252A",
    strokeWidth: 2.0196,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.491 410.336C314.491 410.336 329.505 423.243 318.325 440.456",
    stroke: "#30252A",
    strokeWidth: 2.0196,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.079 387.315C306.079 387.315 306.354 402.769 296.955 402.693",
    stroke: "#30252A",
    strokeWidth: 2.0196,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.544 518.008L424.564 537.562L404.846 463.735L470.242 500.646L449.171 508.317L466.399 529.084L454.244 538.888L437.544 518.008Z",
    fill: "white",
    stroke: "#30252A",
    strokeWidth: 2.42351,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.692 550.014H233.447C224.916 550.014 218 556.929 218 565.459V618.691C218 627.221 224.916 634.136 233.447 634.136H377.692C386.223 634.136 393.139 627.221 393.139 618.691V565.459C393.139 556.929 386.223 550.014 377.692 550.014Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.61568,
    strokeMiterlimit: 10,
    strokeDasharray: "5.95 5.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.899 589.986C250.061 594.261 246.088 598.789 244.78 604.385C243.472 609.982 245.885 616.891 251.383 618.564C256.88 620.237 262.315 616.264 266.532 612.399C279.513 600.49 291.021 587.068 300.808 572.421C302.234 570.293 303.582 567.312 301.877 565.4C299.834 563.109 296.086 565.107 293.922 567.28C285.574 575.668 280.391 587.434 276.964 597.946C275.457 602.573 275.89 608.769 280.152 611.114C282.407 612.349 285.262 612.047 287.599 610.956C289.935 609.864 291.856 608.079 293.737 606.324C299.483 600.967 303.988 596.006 309.729 590.649C311.254 589.229 313.964 586.951 316.043 586.672C326.326 585.283 312.738 621.847 305.152 616.435C299.767 612.593 316.251 597.901 323.192 591.632C335.017 580.998 339.103 589.558 337.232 597.229C335.581 603.993 332.37 618.478 327.31 616.62C322.687 614.938 350.825 579.803 367.751 578.856",
    stroke: "#4756DF",
    strokeWidth: 2.42351,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1479_33433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 519,
    height: 278,
    fill: "white",
    transform: "translate(0 356.014)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWandLadyBranding);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "wand-lady-branding.b3f0885.svg";